<template>
  <v-dialog
    :value="value"
    persistent
    max-width="380"
    @click:outside="cancel()"
    v-bind="$attrs"
    :retain-focus="false"
    v-on="$listeners"
  >
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>{{ message }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">{{ cancelText }}</v-btn>
        <v-btn color="error" text @click="confirm()">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "¡Atención!",
    },
    message: {
      type: String,
      default: "¿Confirmas que quieres continuar?",
    },
    confirmText: {
      type: String,
      default: "Confirmar",
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
    item: undefined,
  },
  methods: {
    cancel() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("input", false);
      if (this.item) {
        this.$emit("confirm", this.item);
      } else this.$emit("confirm");
    },
  },
};
</script>

<style>
</style>